<script lang="ts">
    import { ProductStatuses } from "@modules/products/constants/ProductStatuses";
    import UnavailableProductEntity from "@modules/products/entities/UnavailableProductEntity";
    import { ProductsModule } from "@modules/products/ProductsModule";
    import { createEventDispatcher, onDestroy } from "svelte";
    import { container } from "tsyringe";

    export let productId: number;
    export let token: string;

    const unavailableProductsQuery =
        container.resolve(ProductsModule).exports.unavailableProductsQuery;
    const unavailableProductsService =
        container.resolve(ProductsModule).exports.unavailableProductsService;

    const dispatch = createEventDispatcher();

    const productStatus$ =
        unavailableProductsQuery.selectProductStatus(productId);
    const unavailableProducts$ = unavailableProductsQuery.selectProducts();

    type ProductInfo = { product: UnavailableProductEntity | null };

    let productInfo: ProductInfo = { product: null };

    const productStatusSubscription = productStatus$
        .pipe()
        .subscribe((status) => {
            if (status === undefined) {
                unavailableProductsService.addProductsForFetching(
                    productId,
                    token
                );
            } else if (status === ProductStatuses.READY) {
                dispatch("productReady");
            }
        });

    const unavailableProductsSubscription = unavailableProducts$
        .pipe()
        .subscribe((products) => {
            productInfo = {
                product:
                    (products?.find(
                        (p) => p.id === productId
                    ) as UnavailableProductEntity) || null,
            };
        });

    onDestroy(() => {
        productStatusSubscription?.unsubscribe();
        unavailableProductsSubscription?.unsubscribe();
    });
</script>

<slot {productInfo} />
